/** GraphQL selection for reservation source dropdowns (the fields any signed-in user may read), e.g. the master picker. */
export const RESERVATION_SOURCE_DROPDOWN_QUERY = `
  id
  entityId
  mainInfo { name virtualRs }
  enabled
`;
